"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserPermissions = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // GET user's permissions


var getUserPermissions = function getUserPermissions(host, accessToken) {
  return _axios.default.get("".concat(host, "/permissions/assigned/user"), {
    headers: {
      Authorization: "Bearer ".concat(accessToken),
      'Content-Type': 'application/json'
    }
  }) // return array of permissions
  .then(function (response) {
    return response.data;
  });
};

exports.getUserPermissions = getUserPermissions;